import React, { Fragment, useState, useEffect } from 'react';
import './Workflow.scss';
import './RTEWorkflow.scss';
import ClientInterviewTask from './tasks/ClientInterviewTask'
import HrbTranslate from '../../../../components/language/HrbTranslate';
import Button from '../../../../components/library/buttons/Button';
import IdentityConfirmationTask from './tasks/IdentityConfirmationTask';
import AuthorizationTask from './tasks/AuthorizationTask';
import DocumentUploadTask from './tasks/DocumentUploadTask';
import PrepareReturnRteTask from './tasks/PrepareReturnRteTask';
import ReviewReturnRteTask from './tasks/ReviewReturnRteTask';
import PreparePaymentRteTask from './tasks/PreparePaymentRteTask';
import PaymentRteTask from './tasks/PaymentRteTask';
import FileReturnRteTask from './tasks/FileReturnRteTask';
import SkeletonTask from '../../../../components/library/workflow-tasks/SkeletonTask';
import { WorkflowTasks } from '../../services/WorkflowTasks';
import ContentPlain from '../../../../components/layout/ContentPlain';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { TicketState } from '../../services/TicketState';
import virService from '../../services/vir/VirService';
import TicketActions from '../../../../store/ticketRedux';
import DateTime from '../../../../components/library/common/DateTime';
import { Permissions } from '../../../../app/services/Permissions';

const RTEWorkflow = () => {
    const ticket = useSelector(state => state.tickets.selectedTicket, shallowEqual)
    const closedDate = useSelector(state => {
        var t = state.tickets.selectedTicket;
        if (t) { 
            var currStatus = t.ticketState.identifier
            if (t.stateTransitions && t.stateTransitions.length > 0
                && t.stateTransitions[0].finalState.identifier === currStatus
                && t.stateTransitions[0].timestamp) {
                return t.stateTransitions[0].timestamp
            } else {
                return t.lastModified
            }
        }
        return null;        
    })

    const dispatch = useDispatch();

    const eligibleAddonProducts = useSelector(state => state.tickets.eligibleAddonProducts);

    const isPOMEligible = eligibleAddonProducts && eligibleAddonProducts.length > 0 && eligibleAddonProducts.find(item => item.name === 'POM').length != 0

    useEffect(() => {
        dispatch(TicketActions.getEligibleAddonProducts(ticket.id));
    }, [])

    return (
        <ContentPlain elementId='rte-workflow-tab'>
            <div className='columns level workflow'>
                <div className='column is-7 is-offset-1'>
                    <h3><HrbTranslate text='Tickets.Tasks.Tasks' /></h3>
                </div>
            </div>
            {ticket && ticket.ticketState.identifier !== TicketState.OPEN && ticket.ticketState.identifier !== TicketState.CLOSED && 
                <div className='columns level workflow'>
                    <div className='column is-10 is-offset-1'>
                        <div>
                        {ticket.ticketState.identifier === TicketState.CLOSED_COMPLETED_IN_OFFICE &&
                            <p className='p1'><HrbTranslate text='Tickets.Closed.CompletedInOffice'
                                params={{ TimeStamp: <DateTime value={closedDate} dateAndTime /> }}/></p>
                        }
                        {ticket.ticketState.identifier === TicketState.CLOSED_INCOMPLETE &&
                            <p className='p1'><HrbTranslate text='Tickets.Closed.Incomplete'
                                params={{ TimeStamp: <DateTime value={closedDate} dateAndTime /> }}/></p>
                        }
                        </div>
                    </div>
                </div>
            }
            {ticket &&
                <Fragment>
                    <ClientInterviewTask ticket={ticket} />
                    <IdentityConfirmationTask ticket={ticket} />
                    <AuthorizationTask ticket={ticket} />
                    <DocumentUploadTask ticket={ticket} />
                    <div id='PrepareReturn' className='task-shim'>
                        <PrepareReturnRteTask ticket={ticket} isPOMEligible={isPOMEligible} />
                    </div>
                    <ReviewReturnRteTask ticket={ticket} />
                    <PreparePaymentRteTask ticket={ticket} isPOMEligible={isPOMEligible} />
                    <PaymentRteTask ticket={ticket} />
                    <FileReturnRteTask ticket={ticket} />
                </Fragment>
            }
            {!ticket &&
                <Fragment>
                <SkeletonTask taskId={WorkflowTasks.INTERVIEW_COMPLETED} />
                <SkeletonTask taskId={WorkflowTasks.CONFIRM_ID} />
                <SkeletonTask taskId={WorkflowTasks.AUTHORIZE_CRA} />
                <SkeletonTask taskId={WorkflowTasks.DOCS_UPLOADED} />
                <SkeletonTask taskId={WorkflowTasks.RETURN_PREPARED} />
                <SkeletonTask taskId={WorkflowTasks.RETURN_REVIEWED} />
                <SkeletonTask taskId={WorkflowTasks.PAYMENT_PREPARED} />
                <SkeletonTask taskId={WorkflowTasks.PAYMENT_RECEIVED_RTE} />
                <SkeletonTask taskId={WorkflowTasks.RETURN_FILED} />
                </Fragment>
            }
        </ContentPlain>
    );
}

RTEWorkflow.whyDidYouRender = false;

export default RTEWorkflow